<div class="modal" tabindex="-1" role="dialog" #modal>
    <div class="modal-dialog {{dialogClass}}" [class.vertical-center]="postition === 'center'" role="document">
        <div class="modal-content">
            <div class="modal-header bg-primary">
                <h5 class="modal-title text-white">
                    <ng-content select="[title]"></ng-content>
                </h5>
                <button type="button" class="btn-close" aria-label="Close" *ngIf="!mandatory" (click)="cancel()">
                    <img src="/assets/images/close-icon.svg" alt="Close"/>
                </button>
            </div>
            <ng-content select="[header]"></ng-content>
            <div class="modal-body">
                <ng-content select="[body]"></ng-content>
            </div>
            <div class="modal-footer">
                <ng-content select="[footer]"></ng-content>
            </div>
        </div>
    </div>
</div>
